import { RouteComponentProps } from "@reach/router";
import { FunctionComponent } from "react";
import BackButton from "../../components/back-button/BackButton";
import TabbedView, { TabProps } from "../../components/tabs/TabbedView";
import ConfigureTokenRequestor from "./configure-token-requestor";
import OnboardIssuerPage from "./onboard-issuer";

const tabs: TabProps[] = [
  {
    tabTitle: "Onboard Issuer on CTS",
    tabKey: "onboardIssuer",
    tabContent: <OnboardIssuerPage />
  },
  {
    tabTitle: "Configure Issuer's Token Requestor",
    tabKey: "configureTokenRequestor",
    tabContent: <ConfigureTokenRequestor />
  }
];

const CardTokenizationPage: FunctionComponent<RouteComponentProps> = () => {
  return (
    <section>
      <BackButton
        round
        text="Back to Configuration"
        className="vertical-margin back-button"
      />
      <br />
      <h1 className="title thin vertical-margin spaced">
        Configure Issuer on Interswitch Card Tokenization Service
      </h1>
      <TabbedView tabs={tabs} />
    </section>
  );
};

export default CardTokenizationPage;
